import { render, staticRenderFns } from "./assessment-start-modal.vue?vue&type=template&id=70cca828&scoped=true"
import script from "./assessment-start-modal.vue?vue&type=script&lang=js"
export * from "./assessment-start-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cca828",
  null
  
)

export default component.exports